<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      min-width="70%"
      content-class="basicModal"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="transparent"
          text
          width="52px" 
          height="100%"
          v-bind="attrs"
          v-on="on"
        >
          <basic-button :element="selected"  />
        </v-btn>
      </template>

      
      <div class="input-wrapper modal-elements">
         <div class="classData">
          <h2>{{ title }}</h2>
          <h3 class="studentColor">{{student || 'Todos'}}</h3>
         </div>
        <div class="buttons-options">
          <div v-for="item in options" :key="item.value">
            <v-btn class="iconsSize" color="transparent" text @click="propagateChange(item)">
              <basic-button :element="item"/>
            </v-btn>
            <p class="spaceAround"><b class="item-value">{{item.caption}}</b></p>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import BasicButton from './BasicButton.vue'
export default {
  components: { BasicButton },
  created: function () {
    this.selected = (!this.byDefault) ? this.options[0] : this.byDefault
  },
  props: {
    title: {
      type: String,
      default: () => ''
    },
    student: {
      type: String,
      default: () => ''
    },
    options: Array,
    byDefault: Object
  },
  data () {
    return {
      dialog: false,
      selected: undefined
    }
  },
  methods: {
    setValue: function (value) {
      this.propagateChange(value)
    },
    setEnable: function (value) {
      this.enabled = value
    },
    getClassroom () {
      return this.$store.state.user.classrooms
    },
    propagateChange: function (value) {
      console.log({basicModal: value})
      this.selected = value
      this.dialog = false
      this.$emit('selectedElement',
        { item: value }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryElements/BasicInputModal.vue